import {

	MimaText,
	MimaButton,
	AppPage,
	PageLoader,
	Searchbar,
} from '../../components';
import {
	AddVendorContainer,
	EditVendorContainer,
	ViewVendorContainer,
	DeleteVendorContainer
} from '../../containers';
import MimaOptionMenu from '../../components/OptionMenu';
import styles from '../../assets/styles/Vendor/Vendor.module.scss';
import { useMediaQuery } from 'react-responsive';
import { AnimatePresence } from 'framer-motion';
import React, { useState } from 'react';
import Survey from '../../components/Survey/Survey';
import { userStore } from '../../stores';

const Vendor = ({
	loading,
	vendors,
	addVendorModal,
	goToAddVendor,
	setSelectedVendor,
	closeModal,
	editVendorModal,
	goToEditVendor,
	viewVendorModal,
	goToViewVendor,
	deleteVendorModal,
	goBack,
	refresh,
	handleOptionSelect
}) => {
	const isBelow600 = useMediaQuery({
		query: '(max-width: 600px)',
	});

	const [filteredVendors, setFilteredVendors] = useState([]);
	const [showSurvey, setShowSurvey] = useState(false);

	return (
		<AppPage pageTitle="Vendors" refresh={refresh}>
			<div className={styles.upper}>
				<div className={styles.vendor__num}>
					<MimaText variant="smallBold">{vendors.length} Vendors</MimaText>
					<MimaText variant="xsmall"> Updated 1 min ago </MimaText>
				</div>
				<Searchbar
					placeholder="Search for Vendor Name"
					input={vendors}
					loading={false}
					output={setFilteredVendors}
					handleFilter={(item, searchQuery) => {
						return (
							item?.name?.toLowerCase()?.includes(searchQuery) ||
							item?.mobile?.toLowerCase()?.includes(searchQuery) ||
							item?.email?.toLowerCase()?.includes(searchQuery) ||
							item?.businessCategory?.name?.toLowerCase()?.includes(searchQuery) ||
							item?.services?.toLowerCase()?.includes(searchQuery)
						)
					}}
				/>

				<div className={styles.upper__btns}>
					<MimaButton
						title="Add Vendor"
						variant="small"
						onClick={goToAddVendor}
						mb={1}
					/>

				</div>

			</div>
			<div className={styles.vendor__list}>
				{loading ? (
					<PageLoader
						title="While we set things up for you"
						loading={loading}
					/>
				) : (
					<div className="whiteTable">
						<table>
							<thead>
								<tr>
									<th> Name </th>
									{!isBelow600 && <th> Phone Number</th>}
									{!isBelow600 && <th> Email </th>}
									{!isBelow600 && <th> Category </th>}
									{!isBelow600 && <th> Services </th>}
									<th>Action</th>
								</tr>
							</thead>
							<tbody>
								{filteredVendors.map(vendorDetail => (
									<tr
										key={vendorDetail._id}
										onClick={() => {
											setSelectedVendor(vendorDetail);
											goToViewVendor();
										}}>
										<td>{vendorDetail.name} </td>
										{!isBelow600 && <td> {vendorDetail.mobile} </td>}
										{!isBelow600 && <td> {vendorDetail.email}</td>}
										{!isBelow600 && <td> {vendorDetail.businessCategory?.name} </td>}
										{!isBelow600 && <td> {vendorDetail.services} </td>}
										{/* {!isBelow600 && (
											<td className={styles.minMenu} onClick={showVendorMenu}>
												<BsThreeDotsVertical />
											</td>
										)} */}
										<td style={{cursor: 'pointer'}}>
											<MimaOptionMenu
												options={[
													{
														value: 'edit vendor',
														label: 'Edit vendor',
													},
													{
														value: 'delete vendor',
														label: 'Delete vendor',
													},
													{
														value: 'view more',
														label: 'View more',
													}
												]}
												onOptionSelected={option => {
													handleOptionSelect(vendorDetail._id, vendorDetail, option);
												}}
											/>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				)}
			</div>
			{(addVendorModal || editVendorModal || viewVendorModal || deleteVendorModal || showSurvey) && (
				<div className='modal'>
					<AnimatePresence>
						{addVendorModal && (
						<AddVendorContainer closeModal={closeModal} goBack={goBack} setShowSurvey={setShowSurvey}/>
						)}
						{editVendorModal && (
							<EditVendorContainer closeModal={closeModal} goBack={goBack} setShowSurvey={setShowSurvey}/>
						)}
						{viewVendorModal && (
							<ViewVendorContainer
								closeModal={closeModal}
								goToEditVendor={goToEditVendor}
								goBack={goBack}
							/>
						)}
						{deleteVendorModal && (
							<DeleteVendorContainer closeModal={closeModal} goBack={goBack} />
						)}
						{showSurvey && (
								<Survey
									title=""
									reviewId={userStore.reviewId}
									closeModal={() => {
										setShowSurvey(false);
									}}
								/>
							)}
					</AnimatePresence>
				</div>
			)}
		</AppPage>
	);
};

export default Vendor;
